"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledResponsiveDialog = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const StyledResponsiveDialog = exports.StyledResponsiveDialog = (0, _mui.styled)(_presentationComponents.ResponsiveDialog)({
  [`.${_presentationComponents.responsiveDialogClasses.content}`]: {
    height: '100%'
  },
  [`.${_presentationComponents.responsiveDialogClasses.dialogContent}`]: {
    margin: 0
  }
});
